import React from 'react';
import format from 'date-fns/format';
import isValid from 'date-fns/isValid';

import { DEFAULT_DATE_FORMAT } from 'constants/common';

// import { useModal } from 'hooks/useModal';

import DatePickerInput from './DatePickerInput';

const DatePickerInputContainer = ({
  onChange,
  ...restProps
}: { onChange: any } & Record<string, any>) => {
  // const [datePickerOpen, openDatePicker, closeDatePicker] = useModal({
  //   defaultOpen: false,
  // });

  const handleChange = (event: any) => {
    const value = event?.target?.value ?? '';

    if (onChange) {
      onChange(value);
    }
  };

  const handleDaySelect = (nextDate: any) => {
    if (!nextDate || !isValid(nextDate)) {
      return;
    }

    if (onChange) {
      onChange(format(nextDate, DEFAULT_DATE_FORMAT));
    }

    // closeDatePicker();
  };

  return (
    <DatePickerInput
      {...restProps}
      // datePickerOpen={datePickerOpen}
      onChange={handleChange}
      onDaySelect={handleDaySelect}
    />
  );
};

export default React.memo(DatePickerInputContainer) as any;
